import { postJsonAsync } from './fetchConfig';

export const getFleets = (params) => {
    return postJsonAsync("fleets", params); 
    }